import { LinkProps } from '@types';
import styled from 'styled-components';

export const LinkStyled = styled('a')<LinkProps>`
    color: ${({ theme: { link } }) => link?.color};
    background-color: transparent;
    cursor: pointer;
    text-decoration: ${({ decoration }) => decoration};
    font-weight: ${({ fontWeight }) => `${fontWeight} !important`};
    font-size: ${({ fontSize }) => fontSize};
`;
